const tmpDate = new Date();
const to = tmpDate.toISOString().substring(0, 10);
tmpDate.setFullYear(tmpDate.getFullYear() - 1);
const from = tmpDate.toISOString().substring(0, 10);

export const defaultScope = { scope: { from: from, to: to } };

export const getScope = (days: number) => {
  const tmpDate = new Date();
  const to = tmpDate.toISOString().substring(0, 10);
  tmpDate.setFullYear(tmpDate.getDate() - days);
  const from = tmpDate.toISOString().substring(0, 10);
  return { scope: { from: from, to: to } };
};
